import * as v from "valibot";

// K8s 资源响应是动态 JSON，用 loose schema 做格式校验即可
export const ProxyClusterResourceDataSchema = v.any();
export type ProxyClusterResourceData = v.InferOutput<typeof ProxyClusterResourceDataSchema>;

export const ProxyClusterResourceResponseSchema = v.object({
  RequestId: v.optional(v.string()),
  Data: v.optional(ProxyClusterResourceDataSchema),
  Error: v.optional(
    v.object({
      Code: v.optional(v.string()),
      Message: v.optional(v.string()),
    }),
  ),
});
export type ProxyClusterResourceResponse = v.InferOutput<typeof ProxyClusterResourceResponseSchema>;
